export default __webpack_public_path__ + "static/media/logo-white.ca392de7.png";